function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140Z",
  fill: "#D1AD53"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.7134 109.746C38.9564 109.746 28.8716 109.943 24.5213 110.141V107.57C27.8829 107.175 30.6513 106.186 32.431 104.209C34.6061 102.034 34.8038 99.0677 34.8038 87.9942V43.5027C34.8038 42.1185 34.0129 41.3276 32.8264 41.3276C30.2558 41.3276 27.092 41.5253 22.5439 42.1185V37.966C27.2897 36.3841 36.979 34.0112 42.1202 31.4406C44.6908 30.2541 47.4592 28.4745 50.0298 26.2993L51.6117 27.288C51.0185 37.5705 50.623 59.1242 50.623 78.5027V92.74C50.623 99.4632 50.8208 102.034 52.6004 104.011C54.3801 105.989 57.3462 107.175 60.9055 107.57V110.141C53.5891 109.746 44.8886 109.746 42.7134 109.746Z",
  fill: "#FEF7EA"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.8594 43.8982C64.8594 54.9717 73.5599 61.6949 89.9724 61.6949C110.142 61.6949 115.679 50.8191 116.074 41.5254C116.074 31.8361 111.328 26.8926 104.21 22.3446L98.2775 18.5875C103.405 17.3568 107.203 15.2219 109.672 12.3206C106.643 10.2336 103.442 8.37886 100.095 6.78224C98.9282 13.6302 95.3114 16.4124 95.3114 16.4124L88.5882 12.2598L88.5379 12.2297C85.6139 10.4755 80.4659 7.38708 80.2878 0.750943C76.9296 0.256234 73.4938 0 69.9982 0C69.4316 0 68.8666 0.00673141 68.3032 0.0201184C67.9774 1.43863 67.8255 2.89443 67.8255 4.35022C67.8255 8.89825 68.6164 16.2146 77.317 22.1468L81.865 25.3107C68.6164 29.661 64.8594 35.5932 64.8594 43.8982ZM84.2379 26.6949L93.5317 32.8248C99.6616 36.7796 102.035 39.7457 102.035 46.0734C102.035 50.8191 99.6616 57.1468 89.9724 57.1468C82.656 57.1468 78.108 53.192 78.108 43.1073C78.108 35.9886 79.8876 31.0451 84.2379 26.6949Z",
  fill: "#FEF7EA"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.856 126.113C114.585 120.129 116.327 111.97 116.273 100.847C116.273 73.1636 104.409 67.2314 89.5783 67.2314C65.8495 67.2314 64.2676 86.4122 64.2676 90.367C64.2676 94.7173 64.6631 111.13 86.4145 111.13C94.3241 111.13 98.2789 107.57 100.059 105.593C99.6631 129.717 95.3128 138.022 82.2619 138.022C80.1204 138.022 79.7312 137.919 79.2338 137.788C79.0423 137.737 78.8347 137.682 78.5049 137.627C79.889 136.44 80.68 134.265 80.68 132.288C80.68 128.333 77.9116 125.763 73.5614 125.763C69.4088 125.763 66.4427 128.531 66.4427 132.683C66.4427 135.727 68.2125 138.25 71.4317 139.986C86.5744 139.682 100.537 134.57 111.856 126.113ZM99.2676 85.2258C99.4653 87.9942 99.8608 94.9151 99.8608 102.429H100.256V103.22L100.059 103.418C99.0698 104.011 96.3015 105.593 91.358 105.593C82.6574 105.593 81.0755 98.0789 81.0755 88.9829C81.0755 71.7795 87.4032 71.1862 90.3693 71.1862C96.4992 71.1862 98.2789 75.932 99.2676 85.2258Z",
  fill: "#FEF7EA"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/logo.c5647916.svg";
export { SvgComponent as ReactComponent };